import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 240 240" {...props}>
      <image href="/images/logo.png" width={240}/>
    </Svg>
  );
};

export default Icon;
